"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapValues = mapValues;
function mapValues(obj, key) {
    return Object.entries(obj).reduce((agg, [name, value]) => {
        agg[name] = value[key];
        return agg;
    }, {});
}
//# sourceMappingURL=map-values.js.map